import { memo, useCallback, useMemo, useState } from "react";
import { Select, SelectProps, Spin } from "antd";
import { EntityBase } from "../entities/common";
import { debounce } from "lodash";
import { toPersianString } from "../utils";

export interface DataSelectProps extends SelectProps {
  query: Function;
  filterQueryData?: Function;
  value?: number | number[] | string | string[] | any[];
  displayText: (record: any) => string;
  recordId?: (record: any) => any;
  disabledOption?: (record: any) => boolean;
  placeholder?: string;
  onChange?: (id: number | number[] | string | string[] | any[] | undefined) => void;
  multiple?: Boolean;
  defaultText?: string;
  loadAll?: Boolean;
  filterPredicate?: (record: any, filterText: string) => boolean;
  isPersian?: Boolean;
}

export const DataSelect = memo(
  ({
    query,
    filterQueryData,
    value,
    displayText,
    recordId,
    disabledOption,
    placeholder,
    onChange,
    multiple,
    loadAll,
    filterPredicate,
    isPersian,
    ...rest
  }: DataSelectProps) => {
    const [filterText, SetFilterText] = useState("");
    const { data, isFetching, isUninitialized } = query(!loadAll ? filterText : undefined, { skip: loadAll ? false : !filterText });

    const filteredData = useMemo(() => (filterQueryData && data ? filterQueryData(data) : data ?? []), [data, filterQueryData]);

    const finalData = useMemo(
      () => (loadAll && filterPredicate ? filteredData.filter((x: any) => filterPredicate(x, filterText)) : filteredData),
      [filterPredicate, filterText, filteredData, loadAll]
    );

    const handleSearch = useCallback(
      (newSearchText: string) => {
        if (isPersian) {
          SetFilterText(toPersianString(newSearchText));
        } else {
          SetFilterText(newSearchText);
        }
      },
      [isPersian]
    );

    const handleChange = useCallback(
      (id: number | number[] | string | string[]) => {
        if (onChange) {
          onChange(id);
        }
      },
      [onChange]
    );

    // useEffect(() => {
    //   if (!value || (value instanceof Array && !value.length) || !onChange || !filteredData) return;

    //   if (value instanceof Array) {
    //     const validValues = value.filter((v) => filteredData.some((record: any) => (recordId ? recordId(record) : record.id) === v));
    //     if (value.length !== validValues.length) {
    //       onChange(validValues);
    //     }
    //   } else if (filteredData.every((record: any) => (recordId ? recordId(record) : record.id) === value)) {
    //     onChange(undefined);
    //   }
    // }, [filteredData, onChange, recordId, value]);

    return (
      <Select
        showSearch
        filterOption={false}
        onSearch={!loadAll ? debounce(handleSearch, 500) : handleSearch}
        notFoundContent={isFetching ? <Spin size="small" /> : !isUninitialized ? "موردی پیدا نشد" : null}
        value={value}
        mode={multiple ? "multiple" : undefined}
        onChange={handleChange}
        placeholder={placeholder || "انتخاب کنید"}
        style={{ width: "100%" }}
        allowClear={true}
        options={finalData?.map((record: EntityBase) => ({
          label: displayText(record),
          value: recordId ? recordId(record) : record.id,
          disabled: disabledOption ? disabledOption(record) : false,
        }))}
        {...rest}
      />
    );
  }
);

DataSelect.displayName = "Data Select";
